import { Modal, Button, Box, Grid } from "@mui/material";
import { H5 } from "./Typography";

type MyModalProps = {
  open: boolean;
  handleClose: () => void;
  handleSave: () => void;
  data: any;
};

function GoalWithdrawalModel({ open, handleClose, handleSave }: MyModalProps) {
  const handleSaveClick = () => {
    handleSave();
  };
  const handleCloseSaveClick = () => {
    handleClose();
  };

  return (
    <Modal open={open}>
      <Grid sx={style}>
        <Box sx={header}>
          <H5
            sx={{
              fontFamily: "'Poppins', sans-serif",
              textAlign: "center",
              p: 1.5,
              color: "#fff",
            }}
            fontWeight={"500"}
          >
            Withdraw goal amount
          </H5>
        </Box>
        <H5
          fontSize={16}
          sx={{
            fontFamily: "'Poppins', sans-serif",
            textAlign: "center",
            mt: 5,
            mb: 3,
            color: "#000",
          }}
          fontWeight={"600"}
        >
          Your goal is successfully cancelled
        </H5>

        <Box sx={container}>
          <Box sx={buttonContainer}>
            <Button variant="contained" onClick={handleSaveClick} sx={add}>
              Keep Invested
            </Button>
            <Button
              variant="contained"
              onClick={handleCloseSaveClick}
              sx={close}
            >
              Withdraw
            </Button>
          </Box>
        </Box>
      </Grid>
    </Modal>
  );
}

export default GoalWithdrawalModel;
const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: {
    md: "30%",
    xs: "90%",
  },
  bgcolor: "background.paper",

  boxShadow: 4,

  borderRadius: 2,
  overflow: "hidden",
};
const header = {
  width: "100%",
  bgcolor: process.env.REACT_APP_PRIMARY_COLOR,

  boxShadow: 4,
};
const container = {
  pl: 2,
  pr: 2,
  justifyContent: "center",
  alignItems: "center",
  display: "flex",
  flexDirection: "column",
  pb: 1.5,
};

const buttonContainer = {
  width: "90%",
  justifyContent: "space-between",
  flexDirection: {
    md: "row",
    sm: "row",
    xs: "column",
  },
  display: "flex",

  mt: {
    md: 2.5,
    xs: 1,
  },
};

const close = {
  background: "#FFF5D1",
  color: "#000",
  width: {
    md: "45%",
    sm: "45%",
    xs: "100%",
  },
  mb: 1,
  mt: {
    xs: 2,
  },
  borderRadius: 2,
};
const add = {
  background: process.env.REACT_APP_BUTTON_GRADIENT_COLOR,
  color: "#fff",
  width: {
    md: "45%",
    sm: "45%",
    xs: "100%",
  },
  mb: 1,
  borderRadius: 2,
};
